import { Component, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { State } from '@/store/modal/reducers';
import { modalHide } from '@/store/modal/actions';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html',
  styleUrls: ['./modal.component.css'],
})
export class ModalComponent {

  state: State = {
    title: '',
    text: '',
    text2: '',
    text3: '',
    acceptButtonText: '',
    visible: false,
    noShowButtonBack: true,
    actionOnAccept: () => { },
    actionOnCancel: () => { },
  }

  constructor(
    private store: Store<{ modal: State }>,
  ) {
    const storeSlice$ = this.store.select('modal');
    storeSlice$.subscribe({
      next: (newState) => {
        this.state = newState;
      },
    });

  }

  onAccept() {
    this.onBack();
    this.state.actionOnAccept();
  }

  onBack() {
    this.state.actionOnCancel();
    this.store.dispatch(modalHide());
  }

  replaceAll(str: string, find: string, newString: string): string {
    const regexp = new RegExp(find, 'g');
    return str.replace(regexp, newString);
  }

  splitBreakLines(text: string): string[] {
    const result = text.split('\\n')
      .reduce<string[]>((arr, newText) => ([...arr, ...newText.split('\n')]), []);
    return result;
  }
}
